import {firebaseRoot} from '../utils/firebase-utils';
import untildify from 'untildify';
import Promise from 'bluebird';
import optimist from 'optimist';

async function getUserPointsRef(userId) {
    let ref = await firebaseRoot.child('userData').child(userId).child('points').once('value');
    return ref;
};

async function incPoints(ref, path, val) {
    let points = val;
    if (ref.child(path).child("plus").exists()) {
        points = ref.child(path).child("plus").val() + val;
    }
    ref.ref().child(path).child("plus").set(points);
}

async function decPoints(ref, path, val) {
    let points = val;
    if (ref.child(path).child("minus").exists()) {
        points = ref.child(path).child("minus").val() + val;
    }
    ref.ref().child(path).child("minus").set(points);
}

export async function generateLessonPoints(userId, lessonId) {
    let lesson = await firebaseRoot.child('content').child("lessons").child(lessonId).once('value');
    if (!lesson.exists()) {
        console.log("Invalid lessonId: lesson does not exist.");
        return;
    }

    let conceptId = lesson.val().conceptId;

    let ref = await firebaseRoot.child('userData').child(userId).child('points').once('value');

    await incPoints(ref, "lessons/" + lessonId, 1);
    await incPoints(ref, "concepts/" + conceptId, 1);
    await incPoints(ref, "total", 1);

};

async function setExercisePoints(userId, bookId, chapterId, subchapterId, exerciseId, answerWasCorrect, val) {
    let exercise = await firebaseRoot.child("content/exercises").child(bookId).child(chapterId).child(subchapterId).child(exerciseId).once('value');
    if (!exercise.exists()) {
        await console.log("Invalid exerciseId: exercise does not exist.");
        return;
    }

    let lessonId = exercise.val().lesson;
    let lesson = await firebaseRoot.child('content').child("lessons").child(lessonId).once('value');

    if (!lesson.exists()) {
        await console.log("Invalid lessonId: lesson does not exist.");
        return;
    }

    let conceptId = lesson.val().conceptId;


    let ref = await getUserPointsRef(userId);

    if (answerWasCorrect) {
        incPoints(ref, "lessons/" + lessonId, val);
        incPoints(ref, "concepts/" + conceptId, val);
        incPoints(ref, "total", val);
    } else {
        decPoints(ref, "lessons/" + lessonId, val);
        decPoints(ref, "concepts/" + conceptId, val);
        decPoints(ref, "total", val);
    }
}

export async function generateAssessmentPoints(userId, bookId, chapterId, subchapterId, exerciseId, answerWasCorrect) {
    await setExercisePoints(userId, bookId, chapterId, subchapterId, exerciseId, answerWasCorrect, 3);
};

export async function generateExercisePoints(userId, bookId, chapterId, subchapterId, exerciseId, answerWasCorrect) {
    await setExercisePoints(userId, bookId, chapterId, subchapterId, exerciseId, answerWasCorrect, 1);
};


async function generateSomeUserPoints(userId) {

    await generateLessonPoints(userId, "1");
    await generateAssessmentPoints(userId, "9789140682444", "1", "x1_10x", "9789140682444_1_X1_10X_D_1086_A_GRUNDKURS", true);
    await generateAssessmentPoints(userId, "9789140682444", "1", "x1_10x", "9789140682444_1_X1_10X_D_1086_A_GRUNDKURS", false);
    await generateExercisePoints(userId, "9789140682444", "1", "x1_10x", "9789140682444_1_X1_10X_D_1086_A_GRUNDKURS", true);
    await generateExercisePoints(userId, "9789140682444", "1", "x1_10x", "9789140682444_1_X1_10X_D_1086_A_GRUNDKURS", false);


};

// example: ALBERT_ENV=johan node_modules/.bin/babel-node src/models/PointCalc.js --userId="d377cc4c-fb03-4ac1-8b15-a33a4208b5a2"
async function main() {
    try {
        const readFile = Promise.promisify(require('fs').readFile);
        const argv = optimist.argv;
        console.log("Generating points for userId: " + argv.userId);
        const token = await readFile(untildify('~/.firebase-secret'), 'utf-8');
        await firebaseRoot.authWithCustomToken(token.trim());
        await generateSomeUserPoints(argv.userId);

    } catch (e) {
        console.error(e.stack);
        process.exit(-1);
    }
}

if (require.main === module) {
    main().then(process.exit);
}




/** WEBPACK FOOTER **
 ** ./src/models/PointCalc.js
 **/